module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vc-nav-container"
  }, [_c('div', {
    staticClass: "vc-nav-header"
  }, [_c('span', {
    staticClass: "vc-nav-arrow is-left",
    class: {
      'is-disabled': !_vm.prevItemsEnabled
    },
    attrs: {
      "role": "button",
      "tabindex": _vm.prevItemsEnabled ? 0 : undefined
    },
    on: {
      "click": _vm.movePrev,
      "keydown": function (e) { return _vm.onSpaceOrEnter(e, _vm.movePrev); }
    }
  }, [_vm._t("nav-left-button", [_c('svg-icon', {
    attrs: {
      "name": "left-arrow",
      "width": "20px",
      "height": "24px"
    }
  })])], 2), _vm._v(" "), _c('span', {
    staticClass: "vc-nav-title vc-grid-focus",
    style: ({
      whiteSpace: 'nowrap'
    }),
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleMode,
      "keydown": function (e) { return _vm.onSpaceOrEnter(e, _vm.toggleMode); }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "vc-nav-arrow is-right",
    class: {
      'is-disabled': !_vm.nextItemsEnabled
    },
    attrs: {
      "role": "button",
      "tabindex": _vm.nextItemsEnabled ? 0 : undefined
    },
    on: {
      "click": _vm.moveNext,
      "keydown": function (e) { return _vm.onSpaceOrEnter(e, _vm.moveNext); }
    }
  }, [_vm._t("nav-right-button", [_c('svg-icon', {
    attrs: {
      "name": "right-arrow",
      "width": "20px",
      "height": "24px"
    }
  })])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "vc-nav-items"
  }, _vm._l((_vm.activeItems), function(item) {
    return _c('span', {
      key: item.label,
      class: _vm.getItemClasses(item),
      attrs: {
        "role": "button",
        "data-id": item.id,
        "aria-label": item.ariaLabel,
        "tabindex": item.isDisabled ? undefined : 0
      },
      on: {
        "click": item.click,
        "keydown": function (e) { return _vm.onSpaceOrEnter(e, item.click); }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ef54d25!./~/vue-loader/lib/selector.js?type=template&index=0!./~/v-calendar/src/components/CalendarNav.vue
// module id = 1393
// module chunks = 94